document.documentElement.classList.remove('no-js');

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-mobile-menu]');
  if (!trigger) return;
  const menu = document.querySelector('[data-mobile-panel]');
  if (!menu) return;
  const open = menu.hasAttribute('hidden');
  menu.toggleAttribute('hidden', !open);
  trigger.setAttribute('aria-expanded', String(open));
});

document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const carousel = gallery.querySelector('[data-product-carousel]');
  if (!carousel) return;

  const slides = [...carousel.querySelectorAll('[data-product-slide]')];
  const thumbs = [...gallery.querySelectorAll('[data-carousel-thumb]')];
  const previous = gallery.querySelector('[data-carousel-prev]');
  const next = gallery.querySelector('[data-carousel-next]');
  const currentLabel = gallery.querySelector('[data-carousel-current]');
  const stage = gallery.querySelector('.product-carousel__stage');
  const zoomIn = gallery.querySelector('[data-zoom-in]');
  const zoomOut = gallery.querySelector('[data-zoom-out]');
  const zoomReset = gallery.querySelector('[data-zoom-reset]');

  if (!slides.length || !stage) return;

  let index = 0;
  let timer;
  let pointerStartX = null;
  let zoom = 1;
  let panX = 0;
  let panY = 0;
  let dragging = false;
  let dragStartX = 0;
  let dragStartY = 0;
  let panStartX = 0;
  let panStartY = 0;
  const delay = Number(carousel.dataset.autoplay || 5000);

  const activeImage = () => slides[index]?.querySelector('img, svg');

  const clampPan = () => {
    const image = activeImage();
    if (!image || zoom <= 1) {
      panX = 0;
      panY = 0;
      return;
    }

    const stageRect = stage.getBoundingClientRect();
    const imageRect = image.getBoundingClientRect();
    const maxX = Math.max(0, (imageRect.width - stageRect.width) / 2 / zoom);
    const maxY = Math.max(0, (imageRect.height - stageRect.height) / 2 / zoom);

    panX = Math.max(-maxX, Math.min(maxX, panX));
    panY = Math.max(-maxY, Math.min(maxY, panY));
  };

  const applyZoom = () => {
    clampPan();

    slides.forEach((slide, slideIndex) => {
      const image = slide.querySelector('img, svg');
      if (!image) return;

      if (slideIndex === index) {
        image.style.transform = `translate(${panX}px, ${panY}px) scale(${zoom})`;
        image.style.transformOrigin = 'center center';
        image.style.cursor = zoom > 1 ? (dragging ? 'grabbing' : 'grab') : 'zoom-in';
      } else {
        image.style.transform = 'translate(0, 0) scale(1)';
        image.style.cursor = '';
      }
    });

    stage.classList.toggle('is-zoomed', zoom > 1);

    if (zoomReset) zoomReset.textContent = `${Math.round(zoom * 100)}%`;
    if (zoomOut) zoomOut.disabled = zoom <= 1;
    if (zoomIn) zoomIn.disabled = zoom >= 3;
  };

  const resetZoom = () => {
    zoom = 1;
    panX = 0;
    panY = 0;
    dragging = false;
    applyZoom();
  };

  const show = (nextIndex, restart = true) => {
    index = (nextIndex + slides.length) % slides.length;

    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === index;
      slide.hidden = !active;
      slide.classList.toggle('is-active', active);
    });

    thumbs.forEach((thumb, thumbIndex) => {
      const active = thumbIndex === index;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-current', active ? 'true' : 'false');
    });

    if (currentLabel) currentLabel.textContent = String(index + 1);
    resetZoom();
    if (restart) start();
  };

  const stop = () => {
    if (timer) window.clearInterval(timer);
    timer = undefined;
  };

  const start = () => {
    stop();
    if (document.hidden || zoom > 1 || slides.length < 2) return;
    timer = window.setInterval(() => show(index + 1, false), delay);
  };

  previous?.addEventListener('click', () => show(index - 1));
  next?.addEventListener('click', () => show(index + 1));

  thumbs.forEach((thumb, thumbIndex) => {
    thumb.addEventListener('click', () => show(thumbIndex));
  });

  zoomIn?.addEventListener('click', () => {
    stop();
    zoom = Math.min(3, +(zoom + 0.25).toFixed(2));
    applyZoom();
  });

  zoomOut?.addEventListener('click', () => {
    zoom = Math.max(1, +(zoom - 0.25).toFixed(2));
    if (zoom === 1) {
      panX = 0;
      panY = 0;
    }
    applyZoom();
    if (zoom === 1) start();
  });

  zoomReset?.addEventListener('click', () => {
    resetZoom();
    start();
  });

  stage.addEventListener('dblclick', (event) => {
    if (!event.target.closest('img, svg')) return;
    if (zoom === 1) {
      stop();
      zoom = 2;
    } else {
      zoom = 1;
      panX = 0;
      panY = 0;
    }
    applyZoom();
    if (zoom === 1) start();
  });

  stage.addEventListener('pointerdown', (event) => {
    if (zoom > 1 && event.target.closest('img, svg')) {
      stop();
      dragging = true;
      dragStartX = event.clientX;
      dragStartY = event.clientY;
      panStartX = panX;
      panStartY = panY;
      stage.setPointerCapture?.(event.pointerId);
      applyZoom();
      event.preventDefault();
      return;
    }

    pointerStartX = event.clientX;
  });

  stage.addEventListener('pointermove', (event) => {
    if (!dragging || zoom <= 1) return;
    panX = panStartX + (event.clientX - dragStartX) / zoom;
    panY = panStartY + (event.clientY - dragStartY) / zoom;
    applyZoom();
    event.preventDefault();
  });

  const endDrag = (event) => {
    if (dragging) {
      dragging = false;
      stage.releasePointerCapture?.(event.pointerId);
      applyZoom();
      return;
    }

    if (zoom > 1 || pointerStartX === null || slides.length < 2) {
      pointerStartX = null;
      return;
    }

    const distance = event.clientX - pointerStartX;
    pointerStartX = null;
    if (Math.abs(distance) < 45) return;
    show(distance < 0 ? index + 1 : index - 1);
  };

  stage.addEventListener('pointerup', endDrag);
  stage.addEventListener('pointercancel', endDrag);
  stage.addEventListener('pointerleave', (event) => {
    if (dragging && event.buttons === 0) endDrag(event);
  });

  carousel.addEventListener('mouseenter', stop);
  carousel.addEventListener('mouseleave', () => {
    if (zoom === 1) start();
  });

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stop();
    else if (zoom === 1) start();
  });

  applyZoom();
  start();
});

document.querySelectorAll('[data-product-form]').forEach((form) => {
  const groups = [...form.querySelectorAll('[data-option-group]')];
  const select = form.querySelector('[data-variant-select]');
  const panel = form.closest('[data-product-panel]') || document;
  const productForm = form.querySelector('form');
  const price = panel.querySelector('[data-product-price]');
  const compare = panel.querySelector('[data-product-compare]');
  const addButton = form.querySelector('[data-add-button]');
  const addLabel = form.querySelector('[data-add-label]');
  const qty = form.querySelector('[data-qty]');
  const availabilityLabel = panel.querySelector('[data-availability-label]');
  const availabilityDetail = panel.querySelector('[data-availability-detail]');
  const forceOrder = form.dataset.forceOrder === 'true';

  if (!select) return;

  const findVariant = () => {
    const selected = groups.map((group) => group.querySelector('input:checked')?.value || '');
    return [...select.options].find((option) => {
      const values = [option.dataset.option1 || '', option.dataset.option2 || '', option.dataset.option3 || ''];
      return selected.every((value, index) => values[index] === value);
    });
  };

  const updateVariant = () => {
    groups.forEach((group) => {
      const label = group.querySelector('[data-selected-option]');
      const checked = group.querySelector('input:checked');
      if (label && checked) label.textContent = checked.value;
    });

    const option = findVariant();
    if (!option) {
      select.selectedIndex = -1;
      if (addButton) addButton.disabled = true;
      if (addLabel) addLabel.textContent = 'Unavailable combination';
      if (availabilityLabel) availabilityLabel.textContent = 'Unavailable combination';
      if (availabilityDetail) availabilityDetail.textContent = 'Unavailable combination';
      return;
    }

    select.value = option.value;
    if (price) price.textContent = option.dataset.price || '';
    if (compare) {
      const compareCents = Number(option.dataset.compareCents || 0);
      const priceCents = Number(option.dataset.priceCents || 0);
      const showCompare = compareCents > priceCents;
      compare.hidden = !showCompare;
      compare.textContent = showCompare ? (option.dataset.compare || '') : '';
    }

    const available = forceOrder || option.dataset.available === 'true' || option.dataset.inventoryPolicy === 'continue';
    if (addButton) addButton.disabled = !available;
    if (addLabel) addLabel.textContent = available ? 'Add to bag' : 'Sold out';
    if (availabilityLabel) availabilityLabel.textContent = available ? 'Available to order' : 'Sold out';
    if (availabilityDetail) availabilityDetail.textContent = available ? 'Available to order' : 'Sold out';
  };

  groups.forEach((group) => group.addEventListener('change', updateVariant));

  productForm?.addEventListener('submit', (event) => {
    const option = findVariant();
    if (!option) {
      event.preventDefault();
      updateVariant();
      return;
    }
    select.value = option.value;
  });

  form.querySelector('[data-qty-minus]')?.addEventListener('click', () => {
    if (!qty) return;
    qty.value = String(Math.max(1, Number(qty.value || 1) - 1));
  });

  form.querySelector('[data-qty-plus]')?.addEventListener('click', () => {
    if (!qty) return;
    qty.value = String(Number(qty.value || 1) + 1);
  });

  updateVariant();
});

document.querySelectorAll('[data-home-slider]').forEach((slider) => {
  const slides = [...slider.querySelectorAll('[data-home-slide]')];
  const dots = [...slider.querySelectorAll('[data-home-dot]')];
  const previous = slider.querySelector('[data-home-prev]');
  const next = slider.querySelector('[data-home-next]');
  const delay = Number(slider.dataset.autoplay || 5000);

  if (!slides.length) return;

  let index = 0;
  let timer;

  const stop = () => {
    if (timer) window.clearInterval(timer);
    timer = undefined;
  };

  const show = (nextIndex, restart = true) => {
    index = (nextIndex + slides.length) % slides.length;

    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === index;
      slide.hidden = !active;
      slide.classList.toggle('is-active', active);
    });

    dots.forEach((dot, dotIndex) => {
      const active = dotIndex === index;
      dot.classList.toggle('is-active', active);
      dot.setAttribute('aria-current', active ? 'true' : 'false');
    });

    if (restart) start();
  };

  const start = () => {
    stop();
    if (slides.length < 2 || document.hidden) return;
    timer = window.setInterval(() => show(index + 1, false), delay);
  };

  previous?.addEventListener('click', () => show(index - 1));
  next?.addEventListener('click', () => show(index + 1));
  dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => show(dotIndex)));

  slider.addEventListener('mouseenter', stop);
  slider.addEventListener('mouseleave', start);
  slider.addEventListener('focusin', stop);
  slider.addEventListener('focusout', start);

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) stop();
    else start();
  });

  start();
});

class LeelaraPredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.results = this.querySelector('[data-predictive-search-results]');
    this.abortController = null;
    this.timer = null;
    if (!this.input || !this.results) return;
    this.input.addEventListener('input', () => this.onInput());
    this.input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.close();
    });
    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) this.close();
    });
  }

  onInput() {
    window.clearTimeout(this.timer);
    const term = this.input.value.trim();
    if (term.length < 2) {
      this.close();
      return;
    }
    this.timer = window.setTimeout(() => this.search(term), 180);
  }

  async search(term) {
    this.abortController?.abort();
    this.abortController = new AbortController();
    const sectionId = this.dataset.sectionId || 'predictive-search';
    const url = `${window.Shopify?.routes?.root || '/'}search/suggest?q=${encodeURIComponent(term)}&resources[type]=product,collection,article,page&resources[limit]=6&resources[options][unavailable_products]=last&section_id=${encodeURIComponent(sectionId)}`;
    try {
      const response = await fetch(url, { signal: this.abortController.signal });
      if (!response.ok) throw new Error('Predictive search failed');
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const section = doc.querySelector('#shopify-section-' + sectionId);
      this.results.innerHTML = section ? section.innerHTML : html;
      this.results.hidden = false;
      this.input.setAttribute('aria-expanded', 'true');
    } catch (error) {
      if (error.name !== 'AbortError') this.close();
    }
  }

  close() {
    this.results.hidden = true;
    this.results.innerHTML = '';
    this.input?.setAttribute('aria-expanded', 'false');
  }
}

if (!customElements.get('predictive-search')) {
  customElements.define('predictive-search', LeelaraPredictiveSearch);
}
